<template>
  <nav class="app-top-bar navbar navbar-expand-lg navbar-light">
    <router-link to="/" style="margin-right: 12px; padding: 0;">
      <img src="../assets/infinite-logo-blue.svg" style="height: 29px;"/>
    </router-link>

    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <system-search-bar @select="selectSearchResult" class="m-2 mr-1 my-lg-0"></system-search-bar>

    <div v-if="recentPagesDisplay.length > 0" class="dropdown">
      <a class="nav-link dropdown-toggle" href="#" id="navbarViewsDropdown" role="button" data-toggle="dropdown"
         aria-haspopup="true" aria-expanded="false">
        Recent
      </a>
      <div class="dropdown-menu dropdown-menu-left" aria-labelledby="navbarViewsDropdown">
        <router-link :to="item.url" v-for="item in recentEmployers" :key="item.url" class="dropdown-item">
          <span :class="item.icon"></span> {{ item.text }}
        </router-link>
        <hr v-if="recentEmployers.length && recentParticipants.length" style="margin: 0.3rem 0;"/>
        <router-link :to="item.url" v-for="item in recentParticipants" :key="item.url" class="dropdown-item">
          <span :class="item.icon"></span> {{ item.text }}
        </router-link>
      </div>
    </div>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav ml-auto pull-right">
        <contact-control-panel v-if="isFrontLinePX"></contact-control-panel>
        <amf-dropdown-menu v-if="!isInternalUser" :items="contactUsMenu" title="Contact Us" />
        <amf-dropdown-menu :items="managementMenu" title="Manage" />
        <amf-dropdown-menu :items="toolsMenu" title="Tools" />
        <amf-dropdown-menu :items="resourcesMenu" title="Resources" />
        <top-bar-menu :menu-items="accountMenu" :title="accountMenuTitle"></top-bar-menu>
      </ul>
    </div>
  </nav>
</template>

<script>
import sampleData from '../framework/utils/sample-data'
import SystemSearchBar from './SystemSearchBar.vue';
import bootstrap from 'bootstrap';
import ImpersonationModal from '../user/ImpersonationModal.vue';
import EmployerSpecialistsView from '../employer/EmployerSpecialistsView';
import formatters from '../framework/utils/formatters';
import TopBarMenu from './TopBarMenu';
import html2canvas from "html2canvas";
import UserFeedback from '../user/UserFeedback';
import zendesk from '../framework/utils/zendesk-sso'
import Vue from 'vue';
import ContactControlPanel from "../shared/ContactControlPanel";
import AffordabilityCalculatorModal from "../shared/AffordabilityCalculator";
import { modalService } from '../framework';
import AmfDropdownMenu from '../framework/primitives/AmfDropdownMenu.vue';
import BrokerSpecialistTypeModal from "../broker/BrokerSpecialistTypeModal";
import {chatService} from "../framework/utils/chat-service";
import ameriflexSpecialistsMixin from "../framework/utils/ameriflex-specialists-mixin";
export default {
  components: {ContactControlPanel, SystemSearchBar, AmfDropdownMenu, TopBarMenu, BrokerSpecialistTypeModal},
  mixins: [ameriflexSpecialistsMixin],
  data() {
    return {
      accountMenu: this.buildAccountMenu(),
    }
  },
  computed: {
    ...amfx.map("recent", "recentPages"),
    ...amfx.map("session", "user,impersonatedUser,employers,singleEmployer,userId,apiToken,isFrontLinePX,userRoles:roles"),
    ...amfx.map("userProfile", "firstName,lastName"),
    ...amfx.map("session", "isInternalUser"),
    ...amfx.map("plans", "hasHsa,hasFsa,hasPOP"),
    ...amfx.map('employer/specialists', "state.*"),
    employerId() {
      return this.$route.params.employerId;
    },
    participantId() {
      return this.$route.params.participantId;
    },
    recentPagesDisplay() {
      return this.recentPages
        .map(x => {
          return {
            id: x.id,
            type: x.type,
            icon: x.type == "participant" ? "fa fa-user" : "fa fa-building",
            text: x.name,
            url: "/" + x.route
          }
        });
    },
    recentEmployers() {
      return this.recentPagesDisplay.filter(x => x.type == 'employer');
    },
    recentParticipants() {
      return this.recentPagesDisplay.filter(x => x.type == 'participant');
    },
    accountMenuTitle() {
      if (this.impersonatedUser) {
        return `${this.impersonatedUser.firstName} ${this.impersonatedUser.lastName} (${this.displayName})`;
      } else {
        return this.displayName;
      }
    },
    displayName() {
      let firstName = '';
      if (this.firstName) {
        firstName = this.firstName;
      } else {
        firstName = this.user.firstName;
      }
      let lastName = '';
      if (this.lastName) {
        lastName = this.lastName;
      } else {
        lastName = this.user.firstName;
      }
      return firstName + ' ' + lastName;
    },
    showDashboardLink() {
      let roles = (this.impersonatedUser ? this.impersonatedUser.roles : this.userRoles) || [];
      roles = roles.map(r => r.toLowerCase());

      let prohibitedRoles = ["broker", "producersupport"];

      return _.difference(roles, prohibitedRoles).length > 0;
    },
    managementMenu() {
      let employerNameIndex = this.employers && this.employers.length && this.employers.findIndex(e => e.employerName);
      let employerName = employerNameIndex == 1 ? this.employers[employerNameIndex].employerName : null;
      let homeTitle = employerName ? employerName + " - Home" : "Home";

      return [
        {
          name: 'Dashboard',
          group: 'General',
          onClick: () => { this.$router.push(`/`); },
          visible: !this.singleEmployer && this.showDashboardLink
        },
        {
          name: 'My Employers',
          group: 'General',
          onClick: () => { this.$router.push(`/my-employers`); },
          visible: !this.singleEmployer
        },
        {
          name: homeTitle,
          group: 'General',
          onClick: () => { this.$router.push(`/`); },
          visible: this.singleEmployer
        },
        {
          name: 'Workflows',
          group: 'General',
          onClick: () => { this.$router.push(`/workflows`); },
          visible: this.isInternalUser
        },
        {
          name: 'MyPlanConnect',
          group: 'General',
          onClick: () => { this.$router.push("/mpc-carriers"); },
          visible: this.isInternalUser && this.can.createMyPlanConnectCarriers
        },
        {
          name: 'Pending Issues',
          group: 'General',
          onClick: () => { this.$router.push(`/issues`); },
          visible: this.isInternalUser
        },
        {
          name: 'User Management',
          group: 'People',
          onClick: () => { this.$router.push("/users"); },
          visible: this.isInternalUser && this.can.viewAllUsers
        },
        {
          name: 'CR Team',
          group: 'People',
          onClick: () => { this.$router.push("/teams"); },
          visible: this.isInternalUser && this.can.editTeam
        },
        {
          name: 'CS Team',
          group: 'People',
          onClick: () => { this.$router.push(`/team`); },
          visible: this.isInternalUser
        },
        {
          name: 'Team Stats',
          group: 'People',
          onClick: () => { this.$router.push("/team-stats"); },
          visible: this.can.viewTeamStats
        },
        {
          name: 'Create Broker',
          group: 'Brokers',
          onClick: () => { this.$router.push("/broker/create"); },
          visible: this.isInternalUser && this.can.createBroker
        },
        {
          name: 'Create Agency',
          group: 'Brokers',
          onClick: () => { this.$router.push("/agency/create"); },
          visible: this.isInternalUser && this.can.createAgency
        },
        {
          name: 'Create Partner',
          group: 'Brokers',
          onClick: () => { this.$router.push("/partner/create"); },
          visible: this.isInternalUser && this.can.createPartner
        },
        {
          name: 'Download Broker Specialists',
          group: 'Brokers',
          visible: this.isInternalUser && this.can.assignBrokerSpecialist
        },
        {
          name: 'Upload Broker Specialists',
          group: 'Brokers',
          visible: this.isInternalUser && this.can.assignBrokerSpecialist
        }
      ];
    },
    toolsMenu() {
      return [
        {
          name: 'Admin Console',
          onClick: () => { this.$router.push("/admin-console"); },
          visible: this.isInternalUser && this.can.useCommandLine
        },
        {
          name: 'Claims Portal',
          visible: this.isInternalUser,
          external: true
        },
        {
          name: 'COBRA Portal',
          onClick: () => { window.open("https://cobra.myameriflex.com/", '_blank'); },
          external: true
        },
        {
          name: 'ePOP+',
          onClick: () => { window.open("https://www.epopdocs.com", '_blank'); },
          visible: this.can.viewEpop,
          external: true
        },
        {
          name: 'Claim Rejection Codes',
          onClick: () => { this.$router.push("/claim-rejection-codes"); },
          visible: this.isInternalUser && this.can.editClaimRejectionCodes
        },
        {
          name: 'ICHRA Insurance Quotes',
          onClick: () => { this.$router.push("/medical-quote"); },
          visible: this.can.createInsuranceQuotes
        }
      ];
    },
    resourcesMenu() {
      return [
        {
          name: 'FSA Store Eligibility List',
          onClick: () => { window.open("https://fsastore.com/fsa-eligibility-list?utm_source=AmeriFlex&utm_medium=TPA+Public+Help+Link+EL&a_aid=500f149fbdcc7&utm_campaign=TPA+Partner", '_blank'); },
          external: true
        },
        {
          name: 'HSA Store Eligibility List',
          onClick: () => { window.open("https://hsastore.com/hsa-eligibility-list?utm_source=AmeriFlex&utm_medium=TPA+Public+Help+Link+EL&a_aid=500f149fbdcc7&utm_campaign=TPA+Partner", '_blank'); },
          visible: this.employerId && this.hasHsa,
          external: true
        },
        {
          name: 'FSA/HRA Nondiscrimination Testing',
          onClick: () => { this.$router.push("/nondiscrimination"); }
        },
        {
          name: 'POP Nondiscrimination Testing',
          onClick: () => { this.$router.push(`/employer/${this.employerId}/pop-nondiscrimination`); },
          visible: this.employerId && this.hasPOP
        },
        {
          name: 'ICHRA Affordability Calculator',
          visible: this.isInternalUser && this.can.calculateAffordability
        },
        {
          name: 'Help Center',
          onClick: () => { window.open("https://myameriflex.crunch.help/", '_blank'); },
          external: true
        }
      ];
    },
    contactUsMenu() {
      return  [
        this.createMenuItem("chatWithPrimaryContact", `Chat with ${this.flexAe} (Your Primary Contact)`, () => chatService.openChat(this.flexAePhoneExt), () => this.singleEmployer && this.flexAe && this.showFlex && this.flexAePhone && this.shouldShowChatForExtension(this.flexAePhoneExt)),
        this.createMenuItem("chatWithCobraContact", `Chat with ${this.cobraAe} (COBRA Contact)`, () => chatService.openChat(this.cobraAePhoneExt), () => this.singleEmployer && this.cobraAe && this.showCobra && this.cobraAePhone && this.shouldShowChatForExtension(this.cobraAePhoneExt)),
        this.createMenuItem("emailOrCall", "Email or call", this.showContactUsModal, () => this.singleEmployer),
        this.createMenuItem("startChat", "Start Chat", chatService.openChat, () => !this.singleEmployer),
        this.createMenuItem("requests", "My Requests", this.zendeskLogin, this.isFeatureEnabled('zendesk-sso')),
      ]
    },
  },
  asyncComputed: {
    async claimsPortalLink() {
      let jitbitUrl = '';
      if (this.userId && this.isInternalUser) {
        jitbitUrl = await romeApi.get(`user/${this.userId}/helpdesk`);
      }
      if (jitbitUrl) {
        return `${jitbitUrl}/user/auth?token=${this.apiToken}`;
      }
    },
  },
  async created() {
    await this.load();
  },
  watch: {},
  methods: {
    ...amfx.map("session", "stopImpersonating,setImpersonatedUser"),
    selectSearchResult(result) {
      this.$router.push(result.url);
    },
    async showContactUsModal() {
      hj('tagRecording', ['Clicking Contact Us']);
      var result = await modalService.show("contactus-modal", EmployerSpecialistsView, {width: 800, type: "info"});
      if (result && result.returnUrl) this.$router.push(result.returnUrl);
    },
    createMenuItem(id, text, onClick, visible) {
      let item = {id: id, visible: true};
      if (_.isBoolean(visible)) item.visible = visible;
      if (_.isFunction(visible)) {
        Object.defineProperty(item, "visible", {get: visible});
      }
      if (_.isString(text)) item.text = text;
      if (_.isFunction(text)) {
        Object.defineProperty(item, "text", {get: text});
      }
      if (_.isString(onClick)) item.url = onClick;
      if (_.isFunction(onClick)) {
        item.click = onClick;
      }
      return item;
    },
    buildAccountMenu() {
      let self = this;
      return [
        this.createMenuItem("profile", "Manage Profile", "/userprofile"),
        this.createMenuItem('userhistory', "User Activity", () => {
          location.href = `/#/users/${this.userId}/history`;
        }, () => this.isInternalUser),
        this.createMenuItem("impersonate", "Act on Behalf", this.impersonate, () => this.can.impersonateUser),
        this.createMenuItem("stopImpersonating",
          () => `Back to me (${self.user.firstName} ${self.user.lastName})`,
          this.stopImpersonating,
          () => Boolean(self.impersonatedUser)),
        this.createMenuItem("feedback", "Suggestion Box", this.feedback, () => this.isInternalUser),
        this.createMenuItem("privacy", "Privacy Policy", "https://myameriflex.com/security-privacy-terms-conditions/"),
        this.createMenuItem("contactUs", "Contact Us", this.showContactUsModal, () => this.singleEmployer),
        this.createMenuItem("logout", "Log Out", "/logout"),
      ]
    },
    async feedback() {
      this.busy = true;
      let canvas = await html2canvas(document.body);
      let screenshot = canvas.toDataURL("image/png");
      this.busy = false;
      hj('tagRecording', ['Adding Feedback']);
      var res = await modalService.show("feedback", UserFeedback, {screenshot});
      // console.log("TopBar feedback result:", res);
      if (res && res.contactUs) this.showContactUsModal();
      else toastService.success('Thank you! We appreciate your feedback.');
    },
    async impersonate() {
      var data = await modalService.show("impersonation-modal", ImpersonationModal);
      if (data) {
        await this.setImpersonatedUser(data);
        if (this.$route.fullPath != "/")
          location.href = "/";
        else
          location.reload();
      }
    },
    async load() {
      await this.$store.dispatch('userProfile/load');
      this.$store.dispatch('recent/load', this.userId);
    },
    async zendeskLogin() {
      await zendesk.goToZenDesk(this.userId);
    },
    async iCHRAAffordabilityCalculator() {
      await modalService.show("affordability-calculator-modal", AffordabilityCalculatorModal);
    },
    async downloadBrokerSpecialists() {
        await modalService.show("brokerSpecialistTypeModal", BrokerSpecialistTypeModal, {
            title: "Select Type for Download",
            download: true,
        });
    },
    async uploadBrokerSpecialists() {
        await modalService.show("brokerSpecialistTypeModal", BrokerSpecialistTypeModal, {
            title: "Select File for Upload",
            upload: true,
        });
    },
    async claimsPortal() {
      window.open(this.claimsPortalLink, '_blank');
    },
     async openChat() {
      let url = `${config.romeUi}/chat.html`;
      window.open(`${config.romeUi}/chat.html`, '_blank', 'width=500,height=700,toolbar=0,menubar=0,location=0,popup=yes');
    },
  }
}

</script>

<style lang="scss" scoped>
.fa-phone-medium {
  font-size: 1.5em;
}

.dropdown-header {
  padding-bottom: .2rem;
}

.dropdown-header-contact {
  padding: 0rem 1.5rem;
}

.navbar-expand-lg {
  -ms-flex-flow: row nowrap;
  flex-flow: row nowrap;
  -ms-flex-pack: start;
  justify-content: flex-start;
  background-color: white;
  border-bottom: 1px solid #cdcac3;
}

.quicksearch-dropdown {
  border: 1px solid rgba(0, 0, 0, 0.15);
}

.quicksearch-open {
  color: #fff;
  background-color: #6c757d;
}
</style>



// WEBPACK FOOTER //
// src/framework/TopBar.vue